import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { useQueryParamTerm, useQueryParamsEffect } from 'pricing-pages-ui/utils/urls/appQueryParamUtils';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { BUNDLE } from 'self-service-api/constants/UpgradeProducts';
import BannerSection from '../components/banners/BannerSection';
import IntegrationsSection from '../components/common/IntegrationsSection';
import PhoneSupportFooter from '../components/common/PhoneSupportFooter';
import PhoneSupportMiddle from '../components/common/PhoneSupportMiddle';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import CodeSplitEnvWrapper from '../components/common/env/CodeSplitEnvWrapper';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import ErrorBoundary from '../components/error-boundary/ErrorBoundary';
import { ERROR_SEVERITY } from '../components/error-boundary/error-severity';
import withErrorBoundary from '../components/error-boundary/withErrorBoundary';
import Faq from '../components/faqs/Faq';
import Question from '../components/faqs/Question';
import { MobileSuiteCardContainer } from '../components/merch-card/card-containers/MobileSuiteCardContainer';
import MobileCurrencyPicker from '../components/mobile/MobileCurrencyPicker';
import MobileDropdownNav from '../components/mobile/MobileDropdownNav';
import { SUITE_PAGE, SUITE_PAGE_CONTENT } from '../constants/ErrorBoundaryNames';
import { DEFAULT } from '../constants/ErrorCauses';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { useAnchorLinkScroll } from '../hooks/htmlElementHooks';
import { useGlobalLoading } from '../hooks/loadingHooks';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import ErrorPage from './ErrorPage';
import MissingInfoFallbackPage from './MissingInfoFallbackPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuitePage = () => {
  useAnchorLinkScroll();
  useDocumentTitle('crmSuite');
  const screen = SCREENS.SUITE;
  const isAppReady = useGlobalLoading();
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(MissingInfoFallbackPage, {
      navItem: NavItemEnum.SUITE
    }),
    errorBoundaryName: SUITE_PAGE_CONTENT,
    severity: ERROR_SEVERITY.HIGH,
    children: /*#__PURE__*/_jsxs("div", {
      children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
        name: "SUITE_PAGE"
      }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
        selectedNavItem: NavItemEnum.SUITE
      }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
        children: [/*#__PURE__*/_jsx(BannerSection, {
          screen: screen
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
          children: [/*#__PURE__*/_jsx(ProductPageTitle, {
            nonProductIdentifier: NavItemEnum.SUITE
          }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
            nonProductIdentifier: NavItemEnum.SUITE
          })]
        }), /*#__PURE__*/_jsx(MobileSuiteCardContainer, {
          screen: screen
        }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
          phoneSourceId: "crmsuite-middle",
          screen: screen,
          upgradeProduct: BUNDLE
        }), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/company-proof/CompanyProof`),
          publicComponentProps: {
            tab: 'enterprise'
          }
        }), /*#__PURE__*/_jsx(Faq, {
          children: FaqsConfig[NavItemEnum.SUITE].map(_ref => {
            let {
                questionKey
              } = _ref,
              passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
            return /*#__PURE__*/_jsx(Question, Object.assign({
              questionKey: questionKey
            }, passthroughOptions), questionKey);
          })
        }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
          phoneSourceId: "crmsuite-footer",
          screen: screen,
          upgradeProduct: BUNDLE
        })]
      })]
    })
  });
};
export default withErrorBoundary(MobileSuitePage, {
  FallbackComponent: () => /*#__PURE__*/_jsx(ErrorPage, {
    errorCause: DEFAULT
  }),
  errorBoundaryName: SUITE_PAGE,
  severity: ERROR_SEVERITY.HIGH
});